module.exports = __webpack_public_path__ + "static/img/16.64b54ca9.gif";